import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, EMPTY, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { EHeaderDBMaster } from '../enums/EHeaderDBMaster';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.url.includes('/t-shirt-cafe-admin-login')) return next(req);

    const auth = inject(AuthService);

    if (!auth.tokenApiUser) {
        auth.logout();
        return EMPTY;
    }

    const headers: Record<string, string> = {
        [EHeaderDBMaster.AUTHORIZATION_AM]: auth.tokenApiUser,
    };

    if (auth.tokenDBUser) {
        headers[EHeaderDBMaster.AUTHORIZATION_AM_USER] = auth.tokenDBUser;
    }

    const cloned = req.clone({ setHeaders: headers });

    return next(cloned).pipe(
        catchError(err => {
            if (err.status === 401 || err.status === 403) {
                auth.logout();
            }
            return throwError(() => err);
        })
    );
};
